import * as React from 'react';

import {GridList} from 'shells/grid-list/grid-list';
import {OptionCardChooser} from 'shells/option-card-chooser/option-card-chooser';

import {appHistory} from '../../../../../history';

import type {Page} from '../import-modal';

type Props = {
    onSelectImportType: (selectedPage: Page) => void;
    onCloseModal: () => void;
};

export function Home(props: Props) {
    return (
        <GridList numColumns={3}>
            <OptionCardChooser
                key='csv'
                onClick={() => props.onSelectImportType('csv')}
                illustration='import-spreadsheet'
                title='CSV Spreadsheet'
                subtitle='If you’ve got information in Microsoft Excel, Google Sheets, or a format like CSV, start here.'
            />
            <OptionCardChooser
                key='anotherCrm'
                onClick={() => {
                    if (NutClientConfig.hasImport2CompetitorImporter) {
                        props.onSelectImportType('anotherCrm');
                    } else {
                        props.onCloseModal();
                        appHistory.push('/setup/import/crm');
                    }
                }}
                illustration='import-another-crm'
                title='Another CRM'
                subtitle='Use our one-click importer from your old and and busted CRM via a direct connection.'
            />
            <OptionCardChooser
                key='other'
                onClick={() => {
                    props.onCloseModal();
                    appHistory.push('/setup/import');
                }}
                illustration='magnifying-glass'
                title='Somewhere else'
                subtitle='Email marketing tools, accounting software, or an ERP from 1989, we’ve got you covered!'
            />
        </GridList>
    );
}
